<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<!--<div class="sf-col sf-col-7">-->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pc-idx-num-12-m-search ref="search" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그래프 부분 시작 -->
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-idx-num-12-m-graph ref="graph" @Refresh="Refresh" :scrId="scrId"></pc-idx-num-12-m-graph>
				</sf-card>
			</div>
			<!-- 그래프 부분 끝 -->
			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-8">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-idx-num-12-m-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-idx-num-12-m-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcIdxNum12MSearch from './Search/PcIdxNum12MSearch.vue';
import PcIdxNum12MTable from './Table/PcIdxNum12MTable.vue';
import PcIdxNum12MGraph from './Table/PcIdxNum12MGraph.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcIdxNum12MSearch, PcIdxNum12MTable, PcIdxNum12MGraph },
	methods: {
		Refresh(currentPage = 1, pageUnit = 30) {
			this.$refs.search.searchList(currentPage, pageUnit);
		}
	}
};
</script>

<style></style>
